export default __webpack_public_path__ + "static/sc-congress2-601e3f3eea2ee4b04ef5ae401e04fa8d.webp";